import { getQldRegionGeo, getWaterData } from '../api';

// Internal function
const fetchWaterData = () => {
  return dispatch => {
    // Fetch data from script-generated JSON files
    return getWaterData()
      .then(response => {
        dispatch({ type: 'WATER_DATA:SUCCESS', payload: response });
      })
      .catch(err => {
        dispatch({ type: 'WATER_DATA:ERROR', payload: err });
      });
  };
};


// Internal function
const fetchQldRegionGeo = () => {
  return dispatch => {
    dispatch({ type: 'REGIONS_QLD_GEO:REQUEST' });
    return getQldRegionGeo()
      .then(response => {
        dispatch({ type: 'REGIONS_QLD_GEO:SUCCESS', payload: response });
      })
      .catch(err => {
        dispatch({ type: 'REGIONS_QLD_GEO:ERROR', payload: err });
      });
  };
};


export const fetchRegions = () => {
  return dispatch => {
    dispatch({ type: 'REGIONS_ALL:REQUEST' });
    return Promise.all([
      dispatch(fetchQldRegionGeo()),
      dispatch(fetchWaterData())
    ])
      .then(() => {
        dispatch({ type: 'REGIONS_ALL:SUCCESS' });
      })
      .catch(err => {
        dispatch({ type: 'REGIONS_ALL:ERROR', payload: err });
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/regions.js